import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES } from '../mock/mockData';
import { getCatalogCategories } from '../services/catalogService';

const CategoriesGrid = () => {
  const [categories, setCategories] = useState(CATEGORIES);

  useEffect(() => {
    let mounted = true;
    getCatalogCategories().then(({ categories: catalogCategories }) => {
      if (mounted) setCategories(catalogCategories);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section className="max-w-7xl mx-auto px-4 py-16">
      <div className="text-center mb-10">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1F2A44]">Shop by Categories</h2>
        <p className="mt-2 text-[#1F2A44]/70 max-w-2xl mx-auto text-sm md:text-base">
          Premium sofa sets and recliners, along with well-crafted beds, dining, study, and storage furniture for modern homes.
        </p>
        <div className="flex items-center justify-center mt-4">
          <span className="h-[2px] w-16 bg-[#E8B530]"></span>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
        {categories.map((c) => (
          <Link
            key={c.id}
            to={`/shop/${c.id}`}
            className="group block text-center"
          >
            <div className="relative aspect-square overflow-hidden bg-[#F3EFE8] border border-[#1F2A44]/10 group-hover:border-[#E8B530] transition-colors">
              <img src={c.image} alt={c.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              <div className="absolute inset-0 bg-[#1F2A44]/0 group-hover:bg-[#1F2A44]/20 transition-colors duration-300"></div>
            </div>
            <p className="mt-3 text-sm font-semibold text-[#1F2A44] group-hover:text-[#E8B530] transition-colors">
              {c.name}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default CategoriesGrid;
